import React, { ReactNode, useState } from 'react'
import { useMessages } from '../../hooks/snackbarHooks'
import { useBoolState } from '../../hooks/commonHooks'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { CommissionsDialog } from './CommissionsDialog'
import { OrderCommissionModel } from '../../server/mpsklad_core/Models/OrderCommissionModel'

export type CommissionsButtonBaseProps = {
  title: string

  icon: ReactNode

  loadOrderCommissions: () => Promise<OrderCommissionModel[]>
}

export const CommissionsButtonBase =
  ({title, icon, loadOrderCommissions}: CommissionsButtonBaseProps) => {
    const {showError} = useMessages()

    const [commissions, setCommissions] = useState<OrderCommissionModel[] | null>(null)
    const [isLoading, setLoading, setLoaded] = useBoolState()

    const classes = useStyles()

    const resetCommissions = () => setCommissions(null)

    const onLoadClick =
      async () => {
        setLoading()

        try {
          setCommissions(await loadOrderCommissions())
        } catch (e) {
          console.error('Failed to load commissions', e)
          showError('Не удалось загрузить комиссии.')
        } finally {
          setLoaded()
        }
      }

    return <>
      <span
        className={classes.iconWrap}
        title={title}
        onClick={onLoadClick}
      >
        {icon}
      </span>

      <CommissionsDialog isLoading={isLoading} commissions={commissions} reset={resetCommissions}/>
    </>
  }

const useStyles =
  makeStyles(
    theme => createStyles({
      iconWrap: {
        marginLeft: theme.spacing(1.5),
        marginRight: theme.spacing(0.5),
        display: 'inline-flex',
        cursor: 'pointer'
      }
    }))